import { FormControl, FormHelperText } from "@material-ui/core";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox/Checkbox";
import FormControlLabel, { FormControlLabelProps } from "@material-ui/core/FormControlLabel/FormControlLabel";
import { Controller, FieldError, UseFormMethods } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IProps extends Omit<CheckboxProps, "onChange"> {
    control: UseFormMethods["control"];
    error?: FieldError | undefined;
    isRequired: boolean;
    customRequiredMessage?: string;
    label: FormControlLabelProps["label"];
    name: string;
}

export const CheckboxWrapper = (props: IProps) => {
    const { label, control, name, error, isRequired, customRequiredMessage, ...checkBoxProps } = props;
    const { t } = useTranslation("validation");

    return (
        <Controller
            control={control}
            name={name}
            render={(controllerProps) => (
                <FormControl error={Boolean(error)} style={{ width: "100%" }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                /* eslint-disable-next-line react/jsx-props-no-spreading */
                                {...checkBoxProps}
                                checked={controllerProps.value}
                                color="primary"
                                inputRef={controllerProps.ref}
                                name={controllerProps.name}
                                onChange={(e) => controllerProps.onChange(e.target.checked)}
                            />
                        }
                        label={label}
                    />
                    <FormHelperText id={error ? `error-text-${name}` : ""}>{error ? error.message : ""}</FormHelperText>
                </FormControl>
            )}
            rules={{
                required: isRequired && t((customRequiredMessage as any) || "required"),
            }}
        />
    );
};
